import spinners from "../../../../../../components/loader/spinners"
import _http_v1 from "../../../../../../http_requests/_http_v1"
import("../../../../../../../styles/pages/charts/index/components/groups.css")

export default function GroupList(options){
    let container = options.container
    let GENERAL_OPTIONS = options.general_options
    let button_new_onclick = options.button_new_onclick
    let button_back_onclick = options.button_back_onclick
    let button_edit_onclick = options.button_edit_onclick
    let button_destroy_onclick = options.button_destroy_onclick
    let states = {
        loading: false
    }
    let elements = {
        main_container: undefined,
        group_list:undefined,
        buttons_container: undefined
    }

    let groups_list = []

    initialize()

    function initialize(){
        elements.main_container = generateElement('div', 'group-list-wrapper')
        elements.group_list = generateElement('div', 'group-list')
        elements.buttons_container = generateElement('div', 'group-list-buttons-container mt-3')
        $(elements.main_container).append(elements.group_list, elements.buttons_container)

        $(container).html(elements.main_container)
    }

    this.update = () =>{
        states.loading = true
        toLoadingState()
        getGroups().then(groups=>{
            groups_list = groups
            if(groups_list.length > 0){
                this.buildList(groups_list)
            } else {
                this.buildNoDataLine()
            }
            
        })
        generateButtons()
    }

    this.buildNoDataLine = () =>{
        $(elements.group_list).html("")
        $(elements.group_list).append('<div class="no-data">Nenhum grupo encontrado <i class="far fa-meh ml-2"></i></div>')
    }
    

    this.buildList = (groups) =>{
        $(elements.group_list).html("")
        groups.forEach(group=>{
            $(elements.group_list).append(buildItem(group))
        })
    }

    function generateButtons(){
        elements.buttons_container.innerHTML = ""
        let button_new = generateButton('Novo','btn btn-primary group-list-button-create mr-2')
        let button_back = generateButton('Voltar','btn btn-sm btn-secondary group-list-button-back')
        $(elements.buttons_container).append(button_new,button_back)
        button_new.addEventListener('click', ()=>button_new_onclick())
        button_back.addEventListener('click', ()=>button_back_onclick())
    }

    

    function generateButton(text, klass){
        let element = generateElement('button', klass)
        element.type = 'button'
        element.innerHTML = text
        return element
    }

    function buildItem(group){
        let item = new Item({group:group})
        group.Item = item
        return item.getElement()
    }

    async function getGroups(){
        let station_type_id = GENERAL_OPTIONS.station_type == 'plu' ? 2 : 1
        return _http_v1.get('groups/from_user', {constraints:{'station_type_id': station_type_id}}).then(data=>{
            return data
        })
    }

    function generateElement(type, klass){
        let element = document.createElement(type)
        $(element).addClass(klass)
        return element
    }
    
    function toLoadingState(){
        $(elements.group_list).html("<div class='text-center' style='display:flex;justify-content:center; align-items:center'>"+spinners.defaultSpinner(1, '', '')+"</div>")
    }

    function Item(options){
        let group = options.group
        let element;
        let open = false
        let button_edit_element,button_destroy_element;
        
        this.getElement = ()=>{
            return element
        }

        initialize.call(this)
        
        function initialize(){
            // let context = this
            generateControlButtons()

            element = document.createElement('div')
            element.classList.add('group-list-item')
            element.innerHTML = "<div class='list-item-title'><div class='group-name'>"+group.name+"</div><div><button class='btn-select' type='button'>Selecionar</button><i class='ml-3 fas fa-chevron-down'></i></div></div><div class='list-item-informations'><div class='list-item-informations-members pretty-scrollbar'></div><div class='list-item-informations-buttons'></div></div>"
            $(element).find('.list-item-informations-buttons').append(button_edit_element,button_destroy_element)
            $(element).find('.fa-chevron-down').on('click', ()=>{
                $(element).toggleClass('open')
                toggleInformations()
            })

            $(element).find('.btn-select').on('click', ()=>{
                $(document).trigger('stations:select_multiple', {station_ids: group.group_members.map(x=>x.groupable.id), select: true, show_toast:true})
            })

            $(button_edit_element).on('click', ()=>{
                button_edit_onclick(group)
            })

            $(button_destroy_element).on('click', ()=>{
                button_destroy_onclick(group.id)
            })

            $(element).find()
        }

        function generateControlButtons(){
            button_edit_element = generateControlButton("Editar", "list-item-informations-edit-button")
            button_destroy_element = generateControlButton("Excluir", "list-item-informations-destroy-button")
        }

        function generateControlButton(text, klass){
            let element = document.createElement('button')
            element.type = 'button'
            element.innerText = text
            $(element).addClass(klass)
            return element
        }

        function toggleInformations(){
            if(!open){
                open = true
                $(element).find('.list-item-informations .list-item-informations-members').html(buildInformations())
                $(element).find('.list-item-informations').addClass('open')
            } else {
                open = false
                $(element).find('.list-item-informations').removeClass('open')
            }
        }

        function buildInformations(){
            let html = "<div>"
            group.group_members.forEach(member=>{
                html += "<span class='badge badge-primary mr-1'>"+member.groupable.prefix+"</span>"
            })
            // html += "<div class='date-wrapper'>Criado em: "+group.created_at+"</div>"
            return html
        }
    }
}